import * as React from 'react';
import { cn } from '@/lib/utils';

export interface MobileCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * 是否使用強化的樣式（更明顯的陰影和邊框）
   */
  strong?: boolean;
  /**
   * 是否使用內邊距（inset）
   */
  inset?: boolean;
}

/**
 * iOS 風格卡片容器
 * 用於包裹內容區塊，提供 iOS 風格的圓角、陰影和內邊距
 */
export const MobileCard = React.forwardRef<HTMLDivElement, MobileCardProps>(
  ({ className, strong = false, inset = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-white rounded-2xl',
          strong
            ? 'shadow-lg border border-gray-200'
            : 'shadow-sm border border-gray-100',
          inset ? 'p-4' : 'p-0',
          className
        )}
        {...props}
      />
    );
  }
);
MobileCard.displayName = 'MobileCard';

/**
 * iOS 風格標題組件
 */
export type MobileCardTitleProps = React.HTMLAttributes<HTMLHeadingElement>;

export const MobileCardTitle = React.forwardRef<
  HTMLHeadingElement,
  MobileCardTitleProps
>(({ className, ...props }, ref) => {
  return (
    <h2
      ref={ref}
      className={cn('text-base font-semibold text-gray-900 mb-3', className)}
      {...props}
    />
  );
});
MobileCardTitle.displayName = 'MobileCardTitle';
